import { SkeletonBox } from '../../Product/Skeleton/styled';
import { ChartRow } from '../SelectSizeTable/styled';

export default function SizeSkeleton() {
  return (
    <ChartRow skeleton={true}>
      <SkeletonBox width="40px" height="40px" radius="5px" />
      <SkeletonBox width="40px" height="40px" radius="5px" />
      <SkeletonBox width="40px" height="40px" radius="5px" />
      <SkeletonBox width="40px" height="40px" radius="5px" />
    </ChartRow>
  );
}
